import { cpf, cnpj } from 'cpf-cnpj-validator';

interface DocumentProps {
  type: 'cpf' | 'cnpj';
  value?: string;
}

export const validateDocument = ({ value, type }: DocumentProps) => {
  if (!value) {
    return false;
  }
  if (type === 'cpf') {
    return cpf.isValid(value);
  }
  return cnpj.isValid(value);
};